import a1 from '../../assets/blogdemta/1.jpeg'
import a2 from '../../assets/blogdemta/2.jpg'
import a3 from '../../assets/blogdemta/3.jpg'

export const Blogdata = [
    {
        id: 1,
        title: "Task Management",
        desc: "Managing Tasks can mostly increase your study time as it focus on targets rather than amount of working and studying. Quality is always better but at certain aspect . . . . . . ",
        image: a1,
        url:"https://preciseblogs.pages.dev/blog/Task-execution-and-Confidence",
        date: "03-10-2023 Tuesday",
    },
    {
        id: 2,
        title: "Retention Curve",
        desc: "This Curve is helpful for retaining the concepts and analysing your resources properly. The Curve will show how you should be crucial for Revisions . . . . . .",
        image: a2,
        date: "06-10-2023 Friday",
        url:"https://preciseblogs.pages.dev/blog/Retention-Curve-and-Analysis",
    },
    {
        id: 3,
        title: "Time Management",
        desc: "Time Management is most essential factor. When it comes to compete in most competitive exams of the country. And we will got to know how it can be managed effectively . . . . . . ",
        image: a3,
        url:"https://preciseblogs.pages.dev/blog/Time-Management-and-Efficiency",
        date: "01-10-2023 Sunday",
    }
]